import { AuthenticationResponse } from '~/common/entities/Authentication/AuthenticationRespsone';
import { Api } from '~/common/api/common/api';

export function authenticatedApi(
  authenticationState: AuthenticationResponse | undefined,
) {
  if (!authenticationState) {
    return Api;
  }
  Api.authenticate(authenticationState.token);
  return Api;
}
